import formAPIrecentactivity from "./recentactivity";


var formattedOutput = null;

const formAPIModelrecentactivity = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIrecentactivity(item));


  return formattedOutput
};

export default formAPIModelrecentactivity